/**
 * CartShipmentsProvider
 * Contain most logic handing with Omnitech Api
 */

import _ from 'lodash'
import React from 'react'
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel'
import CartShipmentsContext from './cart-shipments-context'
import {
  fetchCartShipmentAvailablePickupStores,
  fetchCartShipmentAvailableDeliveryDates,
  fetchCartShipmentAvailableDeliveryTimeSlots,
  fetchCartShipmentCourierServices
} from './cart-shipments-api'

export default function CartShipmentsProvider({ children }) {
  function fetchCartShipmentAvailablePickupStoresAll(options) {
    return getAllDataInParallel({
      fn: (args) => fetchCartShipmentAvailablePickupStores({
        ...options,
        ...args,
      }),
      key: 'stores',
    })
  }
  function fetchCartShipmentCourierServicesAll(options) {
    return getAllDataInParallel({
      fn: (args) => fetchCartShipmentCourierServices({
        ...options,
        ...args,
      }),
      key: 'courierServices',
    })
  }
  const contextValue = {
    fetchCartShipmentAvailablePickupStores,
    fetchCartShipmentAvailablePickupStoresAll,
    fetchCartShipmentAvailableDeliveryDates,
    fetchCartShipmentAvailableDeliveryTimeSlots,
    fetchCartShipmentCourierServices,
    fetchCartShipmentCourierServicesAll,
  }
  return (
    <CartShipmentsContext.Provider value={contextValue}>
      {children}
    </CartShipmentsContext.Provider>
  )
}
